const _cache = {};

/**
 * Initialize cache
 */
function initCache() {
    _cache.$carouselWrapper = $(".js-carousel-product-wrapper");
    _cache.carouselSliderWrapperClass = ".carousel-slider-wrapper";
    _cache.jsContentTilesCarousel = (".js-content-tiles-carousel");
}

/**
 * This section defines an object which used for styling a dropdown component.
 */
const dropDownClasses = {
    container: "custom-product-dropdown",
    header: "dropdown-product-header",
    list: "dropdown-product-list",
    item: "dropdown-product-item",
    selected: "dropdown-product-selected",
    dataId: "data-product-id",
    active: "dropdown-product-item-active"
};

/**
 * Event handler for window resize event
 */
$(window).on("resize", function() {
    setTimeout(function() {
        truncateActiveTitle();
    }, 500);
});

/**
 * This function creates the initial markup for a dropdown component.
 * The function first selects the carousel container element and finds all the slides that are not cloned.
 * Maps the tiles and returns an array of objects with the title and index
 * The function then creates a dropdown container element and adds a header element and a list element to it.
 * The header element displays the value of the first item in the `paginationData` array.
 * The list element contains a list of items, each with a value and an id attribute
 * set to the corresponding values in the paginationData array. The first item in the list is given an active class.
 * The function then appends the dropdown container element to the parent
 * of the carousel container element and adds a custom class to the carousel slider wrapper element.
 * Finally, it calls the function to center the dropdown element on the page.
 */
function createInitialMarkup () {
    const $container = _cache.$carouselWrapper.find(".carousel-product");
    const $slides = $container.find(".slick-slide:not(.slick-cloned)");
    const $tiles = $slides.find(".product-tile");
    const paginationData = $tiles.map(function() {
        const $this = $(this);
        const $dataControlTitle = $this.attr("data-control-title");

        if ($dataControlTitle.length === 0) return null;

        return {
            value: $dataControlTitle,
            id: $this.closest(".slick-slide").attr("data-slick-index")
        };
    }).get();

    if (paginationData.length === 0) return;

    const $dropdown = $("<div>").addClass(dropDownClasses.container);
    const $header = $("<div>").addClass(dropDownClasses.header);
    const $selected = $("<span>").addClass(dropDownClasses.selected).text(paginationData[0].value).attr(dropDownClasses.dataId, paginationData[0].id);
    const $list = $("<div>").addClass(dropDownClasses.list);

    $header.append($selected);

    paginationData.forEach(function(item) {
        const $item = $("<div>").addClass(dropDownClasses.item).attr(dropDownClasses.dataId, item.id).text(item.value);
        if (item.id === "0") {
            $item.addClass(dropDownClasses.active);
        }
        $list.append($item);
    });

    $dropdown.append($header, $list);
    $container.parent().after($dropdown);
    _cache.$carouselWrapper.find(_cache.carouselSliderWrapperClass).addClass("custom-dd-padding");
}

/**
 * Handles the click event on the header of the dropdown list
 * @param {Object} $dropdownList - jQuery object of the dropdown list
 */
function handleHeaderClick ($dropdownList) {
    $dropdownList.slideToggle();
}

/**
 * Sets the selected item in the dropdown
 * @param {string} selectedId - the id of the selected item
 */
function setActiveItemClass (selectedId) {
    const $dropdownList = $(`.${dropDownClasses.list}`);
    const $dropdownSelected = $(`.${dropDownClasses.selected}`);
    const $activeItem = $dropdownList.find(`[${dropDownClasses.dataId}="${selectedId}"]`);

    $dropdownSelected.attr(dropDownClasses.dataId, selectedId).text($activeItem.text());
    $dropdownList.find(`.${dropDownClasses.item}`).removeClass(dropDownClasses.active);
    $activeItem.addClass(dropDownClasses.active);
}

/**
 * Handles the click event on the dropdown list item
 * @param {Object} $dropdownList - the dropdown list element
 */
function handleItemClick ($dropdownList) {
    const $this = $(this);
    const selectedId = $this.attr(dropDownClasses.dataId);

    $dropdownList.hide();
    $(".carousel-product.slick-slider").slick("slickGoTo", selectedId);
}

/**
 * Handles outside click events on the dropdown list
 * @param {Object} event - the event object
 * @param {Object} $dropdownList - the jQuery object of the dropdown list
 */
function handleOutsideClick (event, $dropdownList) {
    if (!$(event.target).closest(`.${dropDownClasses.container}`).length) {
        $dropdownList.hide();
    }
}

/**
 * The function initializes a dropdown list then create the initial markup.
 * Attaches a click event listener to the `$dropdownHeader` element that calls
 * the `handleHeaderClick` function with `$dropdownList` as an argument when clicked.
 * Overall, this function sets up the necessary event listeners for the dropdown list to function properly.
 * @param {Object} $dropdownList - the jQuery object of the dropdown list
 */
function createDropdownControls () {
    createInitialMarkup();

    const $dropdownHeader = $(`.${dropDownClasses.header}`);
    const $dropdownList = $(`.${dropDownClasses.list}`);
    $dropdownHeader.click(() => handleHeaderClick($dropdownList));

    $(`.${dropDownClasses.item}`).click(function () { handleItemClick.call(this, $dropdownList); });
    $(document).click(event => handleOutsideClick(event, $dropdownList));
}

/**
 * Checks if the given element has the specified class and change color
 * @param {Object} $el - the slider element
 * @param {string} color - the background color to set
 * @param {string} className - the class name to be added
 * @param {string} addBgValue - the background variable
 */
function changeElementColor ($el, color, className, addBgValue) {
    const slideActiveClass = "slide-circle-active";

    if ($el.hasClass(slideActiveClass)) {
        $el.removeClass(slideActiveClass);
    }

    if (addBgValue) {
        $el.css({ "--slider-background-color": color });
    } else {
        $el.css({ backgroundColor: color });
    }

    $el.addClass(`${className}-active`);
}

/**
* This function is responsible for animating the slide circle by
* changing the color of the slide circle to match the active slide.
* @param {object} $activeSlide - the active slide
*/
function animateSlideCircle ($activeSlide) {
    const className = "slide-circle";
    const $container = $(`.${className}`);
    const color = $activeSlide.data("circle-color");

    changeElementColor($container, color, className);

    setTimeout(() => {
        $container.removeClass(`${className}-active`);
    }, 700);
}

/**
 * Removes the active class from the container
 * Sets the background color of the container
 * @param {string} className - the class name to be removed
 * @param {string} color - the color to set the background to
 */
function animateBackground ($activeSlide) {
    const className = "carousel-slider-wrapper";
    const $container = _cache.$carouselWrapper.find(_cache.carouselSliderWrapperClass);
    const color = $activeSlide.data("bg-color");

    changeElementColor($container, color, className, true);

    setTimeout(() => {
        $container.removeClass(`${className}-active`);
        $container.css({ backgroundColor: color });
    }, 700);
}

/**
 * This function is responsible for animating the carousel by
 * changing the colors of the slide circle and background to match the active slide.
 */
function carouselAnimation () {
    const $activeSlide = _cache.$carouselWrapper.find(".slick-current .product-tile");

    animateSlideCircle($activeSlide);
    animateBackground($activeSlide);
}

/**
 * Initializes a carousel
 * @returns {Object} - the initialized carousel
 */
function initContentCarousel () {
    $(".js-carousel-wrapper").find(_cache.jsContentTilesCarousel).each(function () {
        const $this = $(this);
        const isPhotoText = $this.hasClass("carousel-photo-text");
        const isNews = $this.hasClass("carousel-news");

        if ($this.hasClass("carousel-product") || $this.hasClass("slick-initialized")) {
            return;
        }

        const carouselOptions = isNews ? {
            centerMode: false,
            centerPadding: "0",
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        } : {
            centerMode: !isPhotoText,
            centerPadding: isPhotoText ? "0" : "25%",
            slidesToShow: 1,
            dots: false,
            arrows: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        centerMode: !isPhotoText,
                        centerPadding: isPhotoText ? "0" : "25%",
                        arrows: false,
                        dots: true
                    }
                }
            ]
        };

        $this.slick(carouselOptions);
    });

    /**
     * Initializes the carousel and sets up the necessary event handlers
     */
    _cache.$carouselWrapper.find(_cache.jsContentTilesCarousel).each(function () {
        const $this = $(this);
        if (!$this.hasClass("carousel-product") || $this.hasClass("slick-initialized")) {
            return;
        }

        $this.on("init", function () {
            initCarouselAnimation();
            carouselAnimation();
            createDropdownControls();
            splitWordByLetter();
            truncateActiveTitle();
        }).slick({
            centerMode: true,
            centerPadding: "12.5%",
            slidesToShow: 3,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 700,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        centerMode: true,
                        slidesToShow: 1,
                        centerPadding: "25%",
                        arrows: false,
                        dots: true,
                        customPaging: function (slider, i) {
                            var dotsText = "Go to slide ";

                            // get the translated text based on locale
                            if ($this.attr("data-dot-translation") !== undefined && $this.attr("data-dot-translation") !== "") {
                                dotsText = $this.attr("data-dot-translation") + " ";
                            }

                            return $("<button type=\"button\">"
                                        + "<span class=\"slick-dot-icon\" aria-hidden=\"true\"></span>"
                                        + "<span class=\"slick-sr-only\">" + dotsText + (i+1) + "</span>"
                                    + "</button>");
                        }
                    }
                }
            ],

        }).on("beforeChange", function (event, slick, currentSlideIndex, nextSlideIndex) {
            setActiveItemClass(nextSlideIndex);
            setTimeout(carouselAnimation, 0);
            const totalSlides = slick.slideCount - 1;

            const isSwipeForward = currentSlideIndex - nextSlideIndex === -1 || currentSlideIndex - nextSlideIndex === totalSlides;

            if (isSwipeForward) {
                rotateText(nextSlideIndex);
            } else {
                rotateTextReverse(nextSlideIndex);
            }
        }).on("afterChange", truncateActiveTitle);
    });
}

/**
 * Appends a div element with class 'slide-circle' to the given container
 */
function initCarouselAnimation () {
    const $container = _cache.$carouselWrapper.find(".slick-slider");
    $container.append("<div class='slide-circle'></div>");
}

/**
 * Splits a word into individual letters and wraps each letter in a span
 */
function splitWordByLetter () {
    $(".js-carousel-product-wrapper .ellip").each(function() {
        const $words = $(this).find("span");

        $words.each(function() {
            let letters = $(this).text().split("");
            $(this).empty();

            $.each(letters, function(index, letter) {
                let $span = $("<span>").text(letter === " " ? "\u00A0" : letter).addClass("letter");
                if (letter === " ") {
                    $span.addClass("space");
                }
                $(this).append($span);
            }.bind(this));
        });
    });
}

/**
 * Rotates the animation of the carousel slide titles
 * @param {string} behindClass - the class to be applied to the letters
 * @param {number} nextSlideIndex - the index of the next slide
 */
function rotateAnimation (behindClass, nextSlideIndex) {
    const $slidesActiveSlideTitle = _cache.$carouselWrapper.find(`.slick-slide[data-slick-index='${nextSlideIndex}'] .ellip`);

    $slidesActiveSlideTitle.find("span").children().each((i, letter) => {
        $(letter).removeClass().addClass(`letter ${behindClass}`);
        setTimeout(() => {
            $(letter).removeClass().addClass("letter in");
        }, 300 + i * 10);
    });
}

/**
 * Rotates the text in reverse
 * @param {number} nextSlideIndex - the index of the next slide
 */
function rotateTextReverse (nextSlideIndex) {
    rotateAnimation("behind-reverse", nextSlideIndex);
}

/**
 * Rotates the text on the page
 * @param {number} nextSlideIndex - the index of the next slide to be displayed
 */
function rotateText(nextSlideIndex) {
    rotateAnimation("behind", nextSlideIndex);
}

/**
 * Truncates the active slide title to fit the width and height of the carousel
 * @returns {boolean} Returns true if the title was truncated, false otherwise
 */
function truncateActiveTitle() {
    const $activeSlide = _cache.$carouselWrapper.find(".slick-current");
    const $words = $activeSlide.find(".ellip > span");
    const titleHeight = $activeSlide.find(".ellip").outerHeight();
    const titleWidth = $activeSlide.find(".ellip").outerWidth();
    let tempHeight = 0;
    let tempWidth = 0;
    $words.removeClass("last-word");

    $words.each(function(index) {
        const $word = $(this);
        const wordHeight = $word.outerHeight();
        const wordWidth = $word.outerWidth();

        tempWidth += wordWidth;

        if (tempWidth > titleWidth) {
            tempHeight += wordHeight;
            tempWidth = wordWidth;
        }

        if (tempHeight > titleHeight) {
            $words.eq(index - 1).addClass("last-word");
            return false;
        }

        return true;
    });
}

export default function () {
    initCache();
    initContentCarousel();
}
